import JobsPage from "./JobsPage";

export default JobsPage;
